module.exports = __webpack_public_path__ + "static/media/play.f2c08f50.svg";